import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, toRaw, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import TabsConversion from '@/components/TabsConversion'
import ApplyRecord from './components/ApplyRecord.vue'
import ClueAssign from '../components/ClueAssign.vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import ConcatModal from '@/components/TabsContacts/fbu/editModal.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import DetailForm from './components/DetailForm.vue'
import { salesClueDetail } from '@/api/gucangSales/clueManage'
import { clueTypeEnum } from '@/views/gucangSales/clueManage/dataConfig'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { addToFav, cancelToFav } from '@/api/common'

const __default__ = { name: 'DcCosFbuSalesClueView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()

const queryClueId = computed(() => route.query.clueId as string)
const isPublicClue = computed(() => route.query.isPublicClue) // 是否是从公海池过来的
const clueTypeComputed = computed(() => {
  const find = clueTypeEnum.find((item) => item.value === dataForm?.clueType)
  return find?.label
})
const dataForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})
const permissionFollow = {
  edit: 'fbu_clue_follow_edit_btn',
  del: 'fbu_clue_follow_del_btn',
  comment: 'fbu_clue_follow_comment_btn'
}
const permissionConcat = {
  add: 'fbu_clue_contact_add_btn',
  edit: 'fbu_clue_contact_edit_btn',
  del: 'fbu_clue_contact_del_btn',
  isPublic: isPublicClue.value === '1'
}
const getDetails = () => {
  salesClueDetail({ clueId: queryClueId.value }).then((res) => {
    if (res.data.remindFlag === true) {
      res.data.remindFlag = 1
    } else if (res.data.remindFlag === false) {
      res.data.remindFlag = 0
    } else {
      res.data.remindFlag = undefined
    }
    Object.assign(dataForm, res.data)
  })
}

onBeforeMount(() => getDetails())

const activeTabs = ref('info')
const operationLogRef = ref()
const handleTabsChange = (val: any) => {
  if (val === 'info') {
    getDetails()
  } else if (val === 'logs') {
    operationLogRef.value?.fetch()
  }
}
const goToEdit = () => {
  router.push({ path: '/fbu/salesClue/edit', query: { clueId: queryClueId.value } })
}
// 新增联系人
const contactsRef = ref()
const concatModalRef = ref()
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
const successAddConcat = (type: any) => {
  contactsRef.value?.refresh(type)
  operationLogRef.value?.fetch()
  getDetails()
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  const data = [toRaw(dataForm)]
  clueAssignRef.value?.init(data)
}
const handleAssignPersonSuccess = (follower: string) => {
  getDetails()
  dataForm.follower = follower
}

// 跳转跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: { followRefId: queryClueId.value }
  })
}

// 转潜在客户
const handleTurnPotential = () => {
  if (dataForm.clueType === 3) return message.warning('无效线索不能转潜在客户')
  if (dataForm.dataIntegrity !== 100) {
    AModal.confirm({
      title: '请将客户资料补充完整！',
      content: '将客户信息补充完整，才能转潜在！',
      okText: '完善资料',
      onOk() {
        router.push({ path: '/fbu/salesClue/edit', query: { clueId: dataForm.clueId, isPerfect: 'required' } })
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onCancel() {}
    })
  } else {
    router.push({
      path: '/fbu/business/add',
      query: { saleChanceRefId: dataForm.clueId, isFromPotentialCustomer: 1 }
    })
  }
}
// 收藏
const addFavorite = () => {
  addToFav({
    appId: 'cos_fbu',
    cosId: dataForm.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      dataForm.collectionId = dataForm?.clueId
    }
  })
}
// 收藏
const cancelFavorite = () => {
  cancelToFav({
    appId: 'cos_fbu',
    cosId: dataForm.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      dataForm.collectionId = null
      dataForm.collectionTime = null
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_CosViewContent, {
              header: "",
              title: dataForm?.customerName,
              sellerName: dataForm?.followerName,
              "collection-id": dataForm?.collectionId,
              customLabel: "线索类型",
              customValue: clueTypeComputed.value,
              "add-fav": addFavorite,
              "cancel-fav": cancelFavorite
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tabs, {
                  activeKey: activeTabs.value,
                  "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeTabs).value = $event)),
                  onChange: handleTabsChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "info",
                      tab: "基本信息"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(DetailForm, {
                          ref: "detailFormRef",
                          type: "view",
                          isEdit: false,
                          value: dataForm,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event))
                        }, null, 8, ["value"]),
                        (_unref(route).query.isApplay === '1')
                          ? (_openBlock(), _createBlock(ApplyRecord, {
                              key: 0,
                              title: "审批记录"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "contact",
                      tab: "联系人"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TabsContacts, {
                          ref_key: "contactsRef",
                          ref: contactsRef,
                          appId: "cos_fbu",
                          contactRefId: queryClueId.value,
                          permissionPage: permissionConcat
                        }, null, 8, ["contactRefId"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "record",
                      tab: "跟进记录"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsClueCosFollowUp), {
                          permissionPage: permissionFollow,
                          appId: "cos_fbu",
                          followRefId: queryClueId.value
                        }, null, 8, ["followRefId"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "convert",
                      tab: "转化记录"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsConversion), { resourceId: queryClueId.value }, null, 8, ["resourceId"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "logs",
                      tab: "操作日志"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TabsOperationLog, {
                          ref_key: "operationLogRef",
                          ref: operationLogRef,
                          appId: "cos_fbu",
                          resourceId: queryClueId.value,
                          tableId: "FbuSalesClueOperationLog"
                        }, null, 8, ["resourceId"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]),
              _: 1
            }, 8, ["title", "sellerName", "collection-id", "customValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_cos_footer_button, { hideOk: true }, {
          default: _withCtx(() => [
            (!isPublicClue.value)
              ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleAddConcat()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增联系人")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, permissionConcat.add]
                ])
              : _createCommentVNode("", true),
            (!isPublicClue.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                    controlType: "none",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (goToEdit()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("编辑")
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'fbu_clue_edit_btn']
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleAssignPerson()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("分配负责人")
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'fbu_clue_person_btn']
                  ]),
                  (dataForm.clueStatus !== 8)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                        key: 0,
                        workCode: dataForm.follower,
                        controlType: "none",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleTurnPotential()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("转为潜在客户")
                        ]),
                        _: 1
                      }, 8, ["workCode"])), [
                        [_directive_permission, 'fbu_clue_potential_btn']
                      ])
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (!isPublicClue.value)
              ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  key: 2,
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (handleWriteFollowUp()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("写跟进")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_write_follow_btn']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ClueAssign, {
      ref_key: "clueAssignRef",
      ref: clueAssignRef,
      onFetch: handleAssignPersonSuccess
    }, null, 512),
    _createVNode(ConcatModal, {
      ref_key: "concatModalRef",
      ref: concatModalRef,
      onSuccess: successAddConcat,
      contactRefId: queryClueId.value
    }, null, 8, ["contactRefId"])
  ], 64))
}
}

})